import { NgModule } from '@angular/core'
import { WorkingRoutingModule } from './working-routing.module'
import {
    NbBadgeModule,
    NbButtonModule,
    NbCardModule,
    NbCheckboxModule,
    NbContextMenuModule,
    NbDatepickerModule,
    NbDialogModule,
    NbIconModule,
    NbInputModule,
    NbLayoutModule,
    NbListModule,
    NbSelectModule,
    NbSpinnerModule,
    NbUserModule,
} from '@nebular/theme'
import { NbEvaIconsModule } from '@nebular/eva-icons'
import { CommonModule } from '@angular/common'
import { WorkingComponent } from './main/working.component'
import { ComponentsModule } from '../../components/components.module'
import { FormsModule } from '@angular/forms'
import { TurnOrderComponent } from './turn-order/turn-order.component'
import { GeneralModule } from '../../@core/general.module'
import { TipDistributionComponent } from './tip-distribution/tip-distribution.component'
import { RequestInformationComponent } from './request-information/request-information.component'
import { TimeagoModule } from 'ngx-timeago'
import { DirectivesModule } from '../../@core/directives/directives.module'

@NgModule({
    imports: [
        WorkingRoutingModule,
        NbEvaIconsModule,
        CommonModule,
        NbCardModule,
        NbSelectModule,
        NbDialogModule.forRoot(),
        NbIconModule,
        NbButtonModule,
        NbInputModule,
        NbDatepickerModule,
        NbSpinnerModule,
        ComponentsModule,
        FormsModule,
        NbCheckboxModule,
        NbLayoutModule,
        NbUserModule,
        NbBadgeModule,
        GeneralModule,
        NbListModule,
        TimeagoModule,
        NbContextMenuModule,
        DirectivesModule,
    ],
    declarations: [WorkingComponent, TurnOrderComponent, TipDistributionComponent, RequestInformationComponent],
})
export class WorkingModule {}
